// frontend/modules/account-settings/components/TransaccForm.tsx
import React from 'react';
import { Form, Input, Select, Button, Space } from 'antd';
import { TransaccFormData, ACCOUNT_TYPES } from '../types';
import { CoaDTO } from '@/shared/api/model';
import { useTheme } from '@/components/common/ThemeProvider';

interface TransaccFormProps {
    coaList: CoaDTO[];
    onSubmit: (data: TransaccFormData) => void;
    selectedGl: string;
    setSelectedGl: (gl: string) => void;
    accountType: number;
    setAccountType: (type: number) => void;
    loading?: boolean;
}

export const TransaccForm: React.FC<TransaccFormProps> = ({
                                                              coaList,
                                                              onSubmit,
                                                              selectedGl,
                                                              setSelectedGl,
                                                              accountType,
                                                              setAccountType,
                                                              loading
                                                          }) => {
    const [form] = Form.useForm();
    const { dark } = useTheme();

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            await onSubmit(values);
            form.resetFields();
        } catch (error) {
            console.error('Form validation failed:', error);
        }
    };

    return (
        <Form
            form={form}
            layout="vertical"
            className={dark ? 'dark' : ''}
            onFinish={handleSubmit}
        >
            <Form.Item
                label="Memo code /Gl"
                name="glNo"
                rules={[{ required: true }]}
            >
                <Select
                    value={selectedGl}
                    onChange={setSelectedGl}
                    showSearch
                    optionFilterProp="children"
                >
                    {coaList.map(coa => (
                        <Select.Option key={coa.glNo} value={coa.glNo}>
                            {`${coa.glNo} | ${coa.acName}`}
                        </Select.Option>
                    ))}
                </Select>
            </Form.Item>

            <Form.Item
                label="Account No"
                name="acNo"
                rules={[
                    { required: true },
                    {
                        pattern: /^\d{1,6}$/,
                        message: 'Please enter up to 6 digits'
                    }
                ]}
            >
                <Input maxLength={6} />
            </Form.Item>

            <Form.Item
                label="Description"
                name="acTitle"
                rules={[{ required: true }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label="Account Type"
                name="acctype"
                rules={[{ required: true }]}
            >
                <Select
                    value={accountType}
                    onChange={setAccountType}
                >
                    <Select.Option value={ACCOUNT_TYPES.CASH}>Cash</Select.Option>
                    <Select.Option value={ACCOUNT_TYPES.BANK}>Bank</Select.Option>
                    <Select.Option value={ACCOUNT_TYPES.TRANSFER}>Transfer</Select.Option>
                </Select>
            </Form.Item>

            <Form.Item>
                <Space>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                    >
                        Add
                    </Button>
                    <Button
                        onClick={() => form.resetFields()}
                    >
                        Reset
                    </Button>
                </Space>
            </Form.Item>
        </Form>
    );
};
